module.exports = __webpack_public_path__ + "static/media/down_arrow_black2ca26695.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/down_arrow_black.svg
// module id = 1407
// module chunks = 0